import {NumberUtil, RestClient} from "zavadil-ts-common";
import {NodeUserData, NodeView} from "../../types/Node";

export class NodesClient {

	client: RestClient;

	constructor(client: RestClient) {
		this.client = client;
	}

	roots(): Promise<Array<NodeView>> {
		return this.client.getJson('node/roots');
	}

	children(nodeId: number): Promise<Array<NodeView>> {
		return this.client.getJson('node/children', {nodeId});
	}

	nodeTreePath(nodeId: number): Promise<Array<number>> {
		return this.client.getJson('node/node-tree-path', {nodeId});
	}

	load(id: number): Promise<NodeView> {
		return this.client.getJson(`node/${id}`);
	}

	save(node: NodeUserData): Promise<NodeView> {
		return NumberUtil.isEmpty(node.id)
			? this.client.postJson('node', node)
			: this.client.putJson(`node/${node.id}`, node);
	}

	delete(id: number): Promise<any> {
		return this.client.del(`node/${id}`);
	}

}
